import { getInfo, login, logout, codeLogin, regist } from '@/api/login';
import { getToken, removeToken, setToken } from '@/utils/auth';

const user = {
  state: {
    token: getToken(),
    name: '',
    avatar: '',
    roles: [],
    groups: [],
    groups_name: '',
    permissions: [],
    //缓存新增新的需求时的表单信息的
    cache: 1,
    //别删除，控制账号设置的昵称回显的
    userShow: false,
    userInfo: null, // 用户信息
    geolocationBMap: null,
  },

  mutations: {
    SET_USERSHOW: (state, show) => {
      state.userShow = show;
    },
    SET_CACHE: state => {
      state.cache++;
    },
    SET_TOKEN: (state, token) => {
      state.token = token;
    },
    SET_NAME: (state, name) => {
      state.name = name;
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar;
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles;
    },
    SET_GROUPS: (state, groups) => {
      state.groups = groups;
    },
    SET_GROUPS_NAME: (state, groups_name) => {
      state.groups_name = groups_name;
    },
    SET_PERMISSIONS: (state, permissions) => {
      state.permissions = permissions;
    },

    /**
     * 存储用户信息
     * @param {*} state
     * @param {*} info
     */
    SET_USER_INFO: (state, info) => {
      state.userInfo = info;
    },
    /**
     * 存储用户定位信息
     * @param {*} state
     * @param {*} info
     */
    SET_GEO_LOCATION: (state, info) => {
      state.geolocationBMap = info;
    },
  },

  actions: {
    regist({ commit }, params) {
      return new Promise(async (resolve, reject) => {
        const res = await regist(params)
          .then(res => {
            setToken(res.data.token);
            commit('SET_TOKEN', res.data.token);
            resolve(res);
          })
          .catch(() => {
            reject();
          });
      });
    },
    // 登录
    Login({ commit }, userInfo) {
      const username = userInfo.username.trim();
      const password = userInfo.password;
      const code = userInfo.code;
      const key = userInfo.key;
      const is_keeplogin = userInfo.is_keeplogin;
      return new Promise((resolve, reject) => {
        login(username, password, code, key, is_keeplogin)
          .then(res => {
            setToken(res.data.token);
            // setToken('ttt');
            commit('SET_TOKEN', res.data.token);
            resolve(res);
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    //验证码登录
    CodeLogin({ commit }, userInfo) {
      return new Promise((resolve, reject) => {
        codeLogin(userInfo)
          .then(res => {
            setToken(res.data.token);
            commit('SET_TOKEN', res.data.token);
            resolve(res);
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    // 获取用户信息
    GetInfo({ commit, state, rootState }) {
      return new Promise((resolve, reject) => {
        // const siteConfig = rootState.permission.siteConfig;
        getInfo()
          .then(res => {
            const user = res.data.userinfo;
            const permissions = res.data.permissions;
            // const avatar = user.head_image
            //   ? user.head_image
            //   : siteConfig.site_logo
            //   ? siteConfig.site_logo
            //   : require('@/assets/images/profile.jpg');
            const groups = user.group_ids ? user.group_ids.split(',') : ['DEFAULT']; //后台未分配角色情况
            if (groups && groups.length > 0) {
              // 验证返回的groups是否是一个非空数组
              commit('SET_GROUPS', groups);
              commit('SET_GROUPS_NAME', user.groups_name, { expires: 30 });
            } else {
              commit('SET_GROUPS', ['DEFAULT']);
            }
            const name = user.nickname === null ? user.phone : user.nickname;
            commit('SET_NAME', name);
            // commit('SET_AVATAR', avatar);
            commit('SET_PERMISSIONS', permissions);
            resolve(res);
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    // 退出系统
    LogOut({ commit, state }) {
      return new Promise((resolve, reject) => {
        logout()
          .then(() => {
            commit('SET_TOKEN', '');
            commit('SET_ROLES', []);
            commit('SET_PERMISSIONS', []);
            commit('SET_USER_INFO', null);
            commit('SET_GEO_LOCATION', null);
            removeToken();
            if (!Boolean(localStorage.getItem('is_keeplogin'))) {
              localStorage.clear();
            } else {
              commit('SET_TOKEN', '');
            }
            resolve();
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    // 前端 登出
    FedLogOut({ commit }) {
      return new Promise(resolve => {
        commit('SET_TOKEN', '');
        commit('SET_USER_INFO', null);
        commit('SET_GEO_LOCATION', null);
        removeToken();
        resolve();
      });
    },

    /**
     * 存储用户信息
     * @param {object} info
     */
    setUserInfo({ commit }, info) {
      commit('SET_USER_INFO', info);
    },
    /**
     * 存储用户当前定位
     * @param {object} info
     */
    setgeolocation({ commit }, info) {
      commit('SET_GEO_LOCATION', info);
    },
  },
};

export default user;



// WEBPACK FOOTER //
// ./src/store/modules/user.js